<template>

<portal to="modal">

	<div class="help-modal">

		<div class="help-modal-overlay" v-on:click="$emit('close', false)"></div>

		<div class="help-modal-panel">

			<div class="help-modal-header">
				<div class="help-modal-title">Finding your way around the Osteoporosis Options tool</div>
				<button class="help-modal-close" v-on:click="$emit('close', false)">&times;</button>
			</div>

			<div class="help-modal-body">

				<p>You can work through the sections by pressing the <strong>Next</strong> <span class="help-btn help-btn-next"></span> or <strong>Back</strong> <span class="help-btn help-btn-back"></span> buttons at the bottom of each screen. You can also jump directly to a particular section using the menu on the left-hand side of the screen.</p>

				<p>Please do not use the <strong>back button on your internet browser</strong>, as this will take you back to the Osteoporosis Options homepage.</p>

				<p>To close a window, click the <span class="help-btn help-btn-close">&times;</span> in its top right-hand corner.</p>

				<p>If you have entered either a code from your healthcare professional or your own health information, your results will be visible in the <strong>My Bone Health</strong> section.</p>

			</div>

			<div class="help-modal-foot">

				<label class="help-modal-dismiss">
					<input type="checkbox" v-model="dontShow" /> Don&rsquo;t show this again
				</label>

				<button class="help-modal-button" v-on:click="$emit('close', dontShow)">Got it</button>

			</div>

		</div>

	</div>

</portal>

</template>

<script>

export default {

	data: function() {

		return {
			dontShow: false
		}

	}

}

</script>

<style scoped>

.help-modal {
	position: fixed;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
}

.help-modal-overlay {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	background-color: rgba(0, 0, 0, 0.5);
}

.help-modal-panel {
	position: relative;
	width: 100%;
	max-width: 640px;
	max-height: 90vh;
	overflow-y: auto;
	background-color: #fff;
	border-radius: 24px;
	padding: 32px 40px 24px 40px;
}

.is-mobile .help-modal-panel {
	padding: 24px 20px 20px 20px;
}

.help-modal-header {
	display: flex;
	align-items: flex-start;
	margin-bottom: 20px;
}

.help-modal-title {
	flex: 1;
	font-size: 24px;
	font-weight: 600;
	color: #343434;
	line-height: 30px;
	padding-right: 16px;
}

.is-mobile .help-modal-title {
	font-size: 20px;
	line-height: 26px;
}

.help-modal-close {
	flex-shrink: 0;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: var(--aid-color);
	color: #343434;
	font-size: 22px;
	line-height: 1;
	cursor: pointer;
}

.help-modal-close:hover {
	filter: brightness(90%);
}

.help-modal-body p {
	font-size: 16px;
	line-height: 24px;
	color: #343434;
	font-weight: 300;
	margin-bottom: 16px;
}

/* Inline replicas of the real Next / Back / close buttons */
.help-btn {
	display: inline-block;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	vertical-align: middle;
	margin: 0 2px;
	background-repeat: no-repeat;
	background-position: 50% 50%;
}

.help-btn-next {
	background-color: var(--aid-color);
	background-image: url(~@/assets/section.foot.chevron.svg);
	background-size: 12px auto;
}

.help-btn-back {
	background-color: #c9c9c9;
	background-image: url(~@/assets/section.foot.chevron.svg);
	background-size: 12px auto;
	transform: rotate(180deg);
}

.help-btn-close {
	background-color: var(--aid-color);
	color: #343434;
	font-size: 18px;
	line-height: 26px;
	text-align: center;
	font-weight: 400;
}

.help-modal-foot {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 24px;
	gap: 16px;
}

.is-mobile .help-modal-foot {
	flex-direction: column;
	align-items: stretch;
}

.help-modal-dismiss {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #666;
	cursor: pointer;
}

.help-modal-dismiss input {
	margin-right: 8px;
	cursor: pointer;
}

.help-modal-button {
	flex-shrink: 0;
	padding: 12px 32px;
	border-radius: 24px;
	font-size: 14px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 1px;
	background-color: var(--aid-color);
	color: #343434;
	cursor: pointer;
}

.help-modal-button:hover {
	filter: brightness(90%);
}

</style>
